function stringAnd(strings) {
    return (strings.length <= 1 ? '' : strings.slice(0, -1).join(', ') + ' en ') + strings.slice(-1)[0];
}
